// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Builder_Class from "../Specular.Dom.Builder.Class/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Fix from "../Specular.FRP.Fix/index.js";
import * as Specular_FRP_WeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import * as Specular_JQuery from "../Specular.JQuery/index.js";
import * as Specular_Select from "../Specular.Select/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var initSelect2 = function () {
    return $foreign.initSelect2Impl;
};
var group = Unsafe_Coerce.unsafeCoerce;
var entry = Unsafe_Coerce.unsafeCoerce;
var fromSelectOptions = function (dictShow) {
    var fromSingleOption = function (opt) {
        return {
            id: Data_Show.show(dictShow)(opt.key),
            option: opt.key,
            text: opt.label
        };
    };
    return Data_Functor.map(Data_Functor.functorArray)(function (v) {
        if (v instanceof Specular_Select.OptGroup) {
            return group({
                text: v.value0.label,
                children: Data_Functor.map(Data_Functor.functorArray)(fromSingleOption)(v.value0.options)
            });
        };
        if (v instanceof Specular_Select.SingleOption) {
            return entry(fromSingleOption(v.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Components.MultiSelect (line 116, column 3 - line 120, column 35): " + [ v.constructor.name ]);
    });
};
var multiSelectView = function (dictEq) {
    return function () {
        return function (config) {
            return function (value) {
                var entries = Data_Array.mapWithIndex(function (index) {
                    return function (x) {
                        return {
                            id: Data_Show.show(Data_Show.showInt)(index),
                            text: config.display(x),
                            option: x
                        };
                    };
                })(config.options);
                var findEntry = function (x) {
                    return Data_Array.find(function (e) {
                        return Data_Eq.eq(dictEq)(e.option)(x);
                    })(entries);
                };
                return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Builder_Class["elDynAttr$prime"](Specular_Dom_Builder.monadDomBuilderBuilder)("input")(Control_Applicative.pure(Specular_FRP_WeakDynamic.applicativeWeakDynamic)(Foreign_Object.singleton("type")("hidden")))(Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Data_Unit.unit)))(function (v) {
                    var jq = Specular_JQuery.fromNode(v.value0);
                    return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder)(initSelect2()(jq)({
                        data: Control_Applicative.pure(Effect.applicativeEffect)({
                            results: Data_Functor.map(Data_Functor.functorArray)(entry)(entries)
                        }),
                        containerCssClass: "form-control",
                        multiple: true,
                        placeholder: config.placeholder
                    })))(function () {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_FRP_WeakDynamic.subscribeWeakDyn_(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))((function () {
                            var $13 = $foreign.setValues(jq);
                            var $14 = Data_Array.mapMaybe(findEntry);
                            return function ($15) {
                                return $13($14($15));
                            };
                        })())(value))(function () {
                            return Specular_JQuery.jQueryEventWithSample(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(function (v1) {
                                return Data_Functor.map(Effect.functorEffect)(Data_Functor.map(Data_Functor.functorArray)(function (v2) {
                                    return v2.option;
                                }))($foreign.getValues(jq));
                            })("change")(v.value0);
                        });
                    });
                });
            };
        };
    };
};
var multiSelect = function (dictEq) {
    return function () {
        return function (config) {
            return function (initial) {
                return Specular_FRP_Fix.fixFRP(Specular_FRP_Fix.fixFRPDynamic)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(function (value$prime) {
                    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(multiSelectView(dictEq)()(config)(value$prime))(function (change) {
                        return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_FRP_Base.holdDyn(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(initial)(change))(function (value) {
                            return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(new Data_Tuple.Tuple(value, value));
                        });
                    });
                });
            };
        };
    };
};
export {
    getValues,
    setValues,
    open
} from "./foreign.js";
export {
    multiSelectView,
    multiSelect,
    initSelect2,
    entry,
    group,
    fromSelectOptions
};
//# sourceMappingURL=index.js.map
